<template>
  <div class="text-reading" :class="{ 'is-sign-language': isSignLanguage }">
    <div class="catalog-slot-wrap">
      <div class="catalog-slot">
        <slot />
      </div>
    </div>
    <div class="reader-wrap">
      <bscroll-view
        ref="contentBScroll"
        :pull-up-handler="contentBScrollScrollHandler"
      >
        <div class="main-content-wrap">
          <div class="article-wrap">
            <div class="article-content">
              <h6>
                {{ langTransfer(articleDetail.title) }}
              </h6>
              <p class="author-name">
                {{ langTransfer(articleDetail.author) }}
              </p>
              <div
                ref="articleContainer"
                class="article-container"
                :class="{
                  'font-size-16': fontSizeList[selectedFontSizeIndex] === '16',
                  'font-size-26': fontSizeList[selectedFontSizeIndex] === '26',
                  'font-size-32': fontSizeList[selectedFontSizeIndex] === '32',
                }"
                v-html="langTransfer(articleDetail.content)"
              />
            </div>
          </div>
          <div class="content-related-wrap">
            <slot name="content-related" />
          </div>
          <footer-com />
        </div>
      </bscroll-view>
    </div>
    <div class="actions-wrap">
      <div class="actions-group">
        <button
          class="lr-img-scale"
          :disabled="selectedFontSizeIndex >= fontSizeList.length - 1"
          @click="fontSizeSetting(true)"
        >
          <img
            :src="
              selectedFontSizeIndex >= fontSizeList.length - 1
                ? require('@/assets/img/text-reader-actions/font-big-disable.png')
                : require('@/assets/img/text-reader-actions/font-big.png')
            "
          />
        </button>
        <button
          class="lr-img-scale"
          :disabled="selectedFontSizeIndex <= 0"
          @click="fontSizeSetting()"
        >
          <img
            :src="
              selectedFontSizeIndex <= 0
                ? require('@/assets/img/text-reader-actions/font-small-disable.png')
                : require('@/assets/img/text-reader-actions/font-small.png')
            "
          />
        </button>
      </div>
      <div class="actions-group">
        <button
          v-show="webInfo.isAllowLogin == '1'"
          class="lr-img-scale"
          @click="collectHandler(true)"
        >
          <LottieMarkBtn :is-collection="collectStatus" />
        </button>
        <button
          v-if="hasPrint"
          class="lr-img-scale"
          @click="printArticleContent"
        >
          <img src="@/assets/img/text-reader-actions/print.png" />
        </button>
      </div>
      <div v-if="!hideToggle" class="actions-group">
        <button
          class="lr-img-scale"
          :disabled="limitId.start && $route.params.id === limitId.start"
          @click="chapterChangeHandler(true)"
        >
          <img
            :src="
              limitId.start && $route.params.id === limitId.start
                ? require('@/assets/img/text-reader-actions/prev-disable.png')
                : require('@/assets/img/text-reader-actions/prev.png')
            "
          />
        </button>
        <button
          class="lr-img-scale"
          :disabled="limitId.end && $route.params.id === limitId.end"
          @click="chapterChangeHandler(false)"
        >
          <img
            :src="
              limitId.end && $route.params.id === limitId.end
                ? require('@/assets/img/text-reader-actions/next-disable.png')
                : require('@/assets/img/text-reader-actions/next.png')
            "
          />
        </button>
      </div>
      <div class="actions-group">
        <button
          v-if="hasOriginal"
          class="lr-img-scale"
          @click="originalClickHandler"
        >
          <img src="@/assets/img/text-reader-actions/original.png" />
        </button>
      </div>
    </div>
    <!-- 仅手语阅览室(URL signLang=1)挂载数字人,避免普通站加载插件 -->
    <sign-language-digital-human v-if="$route.query.signLang == '1'" />
    <el-popover
      v-show="qrcodeObj"
      placement="top-start"
      trigger="hover"
      :offset="0"
      popper-class="qrcode-popover"
    >
      <div class="common-qrcode-content">
        <div ref="qrcode" />
      </div>
      <img
        slot="reference"
        class="common-qrcode-popover"
        src="@/assets/img/qrcode.png"
      />
    </el-popover>
  </div>
</template>

<script>
import BscrollView from '@/components/bscrollView';
import FooterCom from '@/components/footerCom/footerCom';
import LottieMarkBtn from '@/components/lottieActions/mark';
import SignLanguageDigitalHuman from '@/components/signLanguageDigitalHuman';
import QRCode from 'qrcodejs2';

export default {
  name: 'TextReading',
  components: {
    FooterCom,
    LottieMarkBtn,
    BscrollView,
    SignLanguageDigitalHuman,
  },
  props: {
    hideScrollBar: {
      type: Boolean,
      default: false,
    },
    articleDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    hasPrint: {
      type: Boolean,
      default: false,
    },
    hasOriginal: {
      type: Boolean,
      default: false,
    },
    collectStatus: {
      type: Boolean,
      default: false,
    },
    collectHandler: {
      type: Function,
      default: undefined,
    },
    chapterChangeHandler: {
      type: Function,
      default: undefined,
    },
    limitId: {
      type: Object,
      default() {
        return {};
      },
    },
    qrcodeUrl: {
      type: String,
      default: '',
    },
    hideToggle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fontSizeList: ['16', '26', '32'],
      selectedFontSizeIndex: 0,
      contentBScrollObj: undefined,
      qrcodeObj: undefined,
    };
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
    isSignLanguage() {
      return this.$route.query.signLang == '1';
    },
  },
  watch: {
    qrcodeUrl(newUrl) {
      if (newUrl) {
        this.initQrCode(newUrl);
      }
    },
  },
  mounted() {
    const storageFontSize = localStorage.getItem('fontSizeIndex');
    if (storageFontSize) {
      this.selectedFontSizeIndex = Number(storageFontSize);
    }
    this.$nextTick(() => {
      this.contentBScrollObj = this.$refs.contentBScroll.bscrollObj;
    });
  },
  methods: {
    initQrCode(text) {
      const ele = this.$refs.qrcode;
      ele.innerHTML = '';
      this.qrcodeObj = new QRCode(ele, {
        width: 110,
        height: 110,
        text,
      });
    },
    contentBScrollScrollHandler(bscrollObj) {
      bscrollObj.refresh();
      // bscrollObj.finishPullUp()
    },
    printArticleContent() {
      const { articleContainer } = this.$refs;
      const newContent = articleContainer.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
    },
    fontSizeSetting(isBigger) {
      if (isBigger) {
        this.selectedFontSizeIndex += 1;
      } else {
        this.selectedFontSizeIndex -= 1;
      }
      if (this.selectedFontSizeIndex < 0) {
        this.selectedFontSizeIndex = 0;
      }
      if (this.selectedFontSizeIndex > this.fontSizeList.length - 1) {
        this.selectedFontSizeIndex = this.fontSizeList.length - 1;
      }
      localStorage.setItem('fontSizeIndex', this.selectedFontSizeIndex);
    },
    originalClickHandler(e) {
      console.log(this.articleDetail);
      //   const { href } = router.resolve({
      //     name: "magazineContent",
      //     params,
      //   });
      //   window.open(href, "_blank");
      // const { href } = this.$router.resolve({
      //     path: '/epub',
      //     query: {
      //         bookname: this.dataList.name,
      //         codename: this.dataList.codename,
      //         year: this.$route.query.year,
      //         issue: this.$route.query.issue,
      //         pagecount: Number(this.dataList.pagecount),
      //         bookid: this.$route.query.id
      //     }
      // })
      // window.open(href, '_blank')
      this.$emit('originalClick', 123321);
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .article-wrap {
    width: calc(50vw + 240px);
  }
  .content-related-wrap {
    width: calc(50vw + 240px);
  }
  /* 操作栏贴正文区右侧:正文居中,右边缘到视口边 = (100vw - 正文宽)/2 = 25vw - 120px */
  .actions-wrap {
    right: calc(25vw - 120px);
  }
}
@media screen and (max-width: 1280px) {
  .article-wrap {
    width: calc(50vw + 208px);
  }
  .content-related-wrap {
    width: calc(50vw + 208px);
  }
  /* 操作栏贴正文区右侧:正文右边缘到视口边 = (100vw - 正文宽)/2 = 25vw - 104px */
  .actions-wrap {
    right: calc(25vw - 104px);
  }
}
.text-reading {
  width: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  position: relative;
}

/* 仅手语阅览室:整体左移 180px,给右侧数字人面板腾位(目录+正文+操作栏一起移,面板贴视口右不动) */
.text-reading.is-sign-language {
  margin-left: -180px;
}

.catalog-slot-wrap {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 0;
  left: 50%;
  right: 0;
  bottom: 0;
  z-index: 2;
  margin-left: -600px;
}

.catalog-slot {
  width: 100%;
  max-height: calc(100vh - 60px - 20px - 20px - 50px);
  height: calc(100vh - 60px - 20px - 20px - 50px);
  margin-top: 20px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.reader-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.main-content-wrap {
  width: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}

.article-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 60px;
}

.article-content {
  width: 740px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  h6 {
    font-size: 30px;
    font-family: AlibabaPuHuiTiB;
    color: #000000;
    line-height: 36px;
    margin: 80px 0 20px;
  }

  .author-name {
    margin-bottom: 30px;
    font-size: 13px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 24px;
  }

  .article-container {
    width: 100%;
  }
}

.content-related-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 30px;
}

.actions-wrap {
  width: 36px;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.actions-group {
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }

  button {
    width: 36px;
    height: 36px;
    box-sizing: border-box;
    padding: 6px;
    margin-top: 10px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    transition: all 0.3s;

    &:first-child {
      margin-top: 0;
    }

    &:hover {
      background: #f5f7fa;
    }

    &:active {
      background: #e4e7ed;
    }
  }

  button:disabled {
    &:hover {
      background: #ffffff;
    }

    &:active {
      background: #ffffff;
    }
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.common-qrcode-popover {
  // left: calc(50vw - 600px - 94px);
  left: 10px;
  bottom: 100px;
}
</style>

<style>
.article-container p {
  width: 100%;
  font-family: AlibabaPuHuiTiR;
  color: #303133;
  margin-bottom: 1em;
  word-break: break-all;
}

.article-container p img {
  margin-left: 2em;
}

.article-container figure img {
  width: 100%;
}

.article-container img {
  max-width: 780px;
  margin: 0 auto 20px;
}
.article-container h1,
.article-container h2,
.article-container h3,
.article-container h4,
.article-container h5 {
  line-height: 1.6em;
  font-weight: bold;
  margin-top: 1em;
  margin-bottom: 0.5em;
}

.font-size-16 {
  font-size: 16px;
}

.font-size-16 h1 {
  font-size: 40px;
}
.font-size-16 h2 {
  font-size: 32px;
}
.font-size-16 h3 {
  font-size: 24px;
}
.font-size-16 h4 {
  font-size: 19px;
}
.font-size-16 h5 {
  font-size: 16px;
}

.font-size-26 {
  font-size: 26px;
}

.font-size-26 h1 {
  font-size: 65px;
}
.font-size-26 h2 {
  font-size: 52px;
}
.font-size-26 h3 {
  font-size: 39px;
}
.font-size-26 h4 {
  font-size: 31px;
}
.font-size-26 h5 {
  font-size: 26px;
}

.font-size-32 {
  font-size: 32px;
}
.font-size-32 h1 {
  font-size: 80px;
}
.font-size-32 h2 {
  font-size: 64px;
}
.font-size-32 h3 {
  font-size: 48px;
}
.font-size-32 h4 {
  font-size: 38px;
}
.font-size-32 h5 {
  font-size: 32px;
}
</style>
